// extracted by mini-css-extract-plugin
var _1 = "ButtonIconMinimize-moduleButtonIconMinimize__WEJ7d ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
var _2 = "ButtonIconMinimize-modulebottom__lV7q4";
var _3 = "ButtonIconMinimize-modulebottom16__iWGq2 ButtonIconMinimize-modulebottom__lV7q4";
var _4 = "ButtonIconMinimize-modulebottom24__ypTN4 ButtonIconMinimize-modulebottom__lV7q4";
var _5 = "ButtonIconMinimize-moduletop__tQKq5";
var _6 = "ButtonIconMinimize-moduletop16__ZF24v ButtonIconMinimize-moduletop__tQKq5";
var _7 = "ButtonIconMinimize-moduletop24__ehrDv ButtonIconMinimize-moduletop__tQKq5";
export { _1 as "ButtonIconMinimize", _2 as "bottom", _3 as "bottom16", _4 as "bottom24", _5 as "top", _6 as "top16", _7 as "top24" }
